
import hr from '../assets/curve-hr.svg'
export default function HR() {
  return (
    <div>
      <img src={hr} className='w-full md:h-3 mt-8' alt='hr' />
    </div>
  )
}
